import { StageDef } from '../automationMachineInterfaces'
import {
  generateContentUpdateStageDefs,
  ACTION,
  CONTENT,
} from './instagramYourContentUtils'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
} from '../recommendationCardDisplayUtils'

const getCurrentValueFn = () => () => ''
const getIsFulfilledFn = () => () => true
const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

const gatherStageDefs: StageDef[] = []

const updateStageDefs: StageDef[] = generateContentUpdateStageDefs(
  ACTION.ARCHIVE,
  [CONTENT.POSTS],
)

const undoStageDefs: StageDef[] = []

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
